import { TRANSLATION_KEYS as KEY_INITIATIVES_TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'

import { FINANCIAL_COCKPIT_NAMESPACE } from '../../../../configs/translations'

const PREFIX = `${FINANCIAL_COCKPIT_NAMESPACE}-initiatives-quality`

export const TRANSLATION_KEYS = {
  financialPlanCoverage: KEY_INITIATIVES_TRANSLATION_KEYS.quality.financialPlanCoverage.title,
  descriptionQuality: KEY_INITIATIVES_TRANSLATION_KEYS.quality.descriptionQuality.title,
  strategicGrowthAreas: KEY_INITIATIVES_TRANSLATION_KEYS.quality.strategicAlignment.title,
  financialIncremental: `${PREFIX}-financial-incremental`,
  initiativeIncrementalPlan: `${PREFIX}-initiative-incremental-plan`,
  totalInitiatives: `${PREFIX}-total-initiatives`,
  wellDescribedInitiatives: `${PREFIX}-well-described-initiatives`,
  totalAreas: `${PREFIX}-total-areas`,
  coveredAreas: `${PREFIX}-covered-areas`,
  score: `${PREFIX}-score`,
}
